import { useMemo } from "react";
import Link from "admin/shared/ui/Link.Component";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";

import { currencyTag, numberWithSpaces } from "../../../../utilities/formaters";
import { Currencies } from "../../../../shared/dictionary/enums";

import { accountingConnector } from "../../../../services/accounting/connector";
import TableNew, { CELL_TYPES } from "../../../../shared/Table";
import { compose } from "redux";
import amlConnector from "../../../../services/aml/amlConnector";

const AmlFlaggedDepositsContent = ({
  accounting,
  idsToExcludeFromTransfer,
  itemsToExclude,
}) => {
  const [dataAml, sumOfSekInvestorDepositsAml, sumOfEurInvestorDepositsAml] =
    useMemo(() => {
      const dataAml = [...accounting.investorDepositsToTransfer.dataAml].sort(
        (a, b) => {
          return (
            new Date(b.AmlWarningDetails?.Created) -
            new Date(a.AmlWarningDetails?.Created)
          );
        },
      );

      const sumOfSekInvestorDepositsAml = dataAml.reduce((memo, item) => {
        return idsToExcludeFromTransfer(item) ||
          item.Currency !== currencyTag[Currencies.Sek]
          ? memo
          : item.Amount + memo;
      }, 0);

      const sumOfEurInvestorDepositsAml = dataAml.reduce((memo, item) => {
        return idsToExcludeFromTransfer(item) ||
          item.Currency !== currencyTag[Currencies.Eur]
          ? memo
          : item.Amount + memo;
      }, 0);

      return [
        dataAml,
        sumOfSekInvestorDepositsAml,
        sumOfEurInvestorDepositsAml,
      ];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accounting.investorDepositsToTransfer.dataAml, itemsToExclude]);

  const columns = getColumns();

  return (
    <div className="content-padding">
      <Card>
        <CardHeader
          title={`AML under verification deposits (${numberWithSpaces(sumOfSekInvestorDepositsAml)} ${currencyTag[Currencies.Sek]}, ${numberWithSpaces(sumOfEurInvestorDepositsAml)} ${currencyTag[Currencies.Eur]})`}
        />
      </Card>
      <Card>
        <CardContent>
          <CardHeader title={"Deposits under AML verification"} />
          <TableNew
            columns={columns}
            items={dataAml}
            actionColumnWidth={220}
            tableKey="aml_flagged_deposits"
          />
        </CardContent>
      </Card>
    </div>
  );

  function getColumns() {
    return [
      {
        key: "InvestorId",
        label: "InvestorId",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return (
            <Link toState={"userOverview"} parameters={["identity", value]}>
              {value}
            </Link>
          );
        },
      },
      {
        key: "UniqueRef",
        label: "PaymentId",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "DepositOcr", label: "OCR", visible: true, type: CELL_TYPES.text },
      { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.text },
      {
        key: "Currency",
        label: "Currency",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "DepotId",
        label: "DepotId",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "AmlWarningDetails",
        label: "Aml Warning",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <div>{value?.Trigger}</div>;
        },
      },
      {
        key: "AmlWarningDetails",
        label: "Aml Status",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <div>{value?.CurrentStatus}</div>;
        },
      },
      {
        key: "AmlWarningDetails",
        label: "Aml Note",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return (
            <div>
              {value?.Notes &&
                [...value.Notes].sort((a, b) => {
                  return new Date(b.Created) - new Date(a.Created);
                })[0]?.Note}
            </div>
          );
        },
      },
      {
        key: "AmlWarningDetails",
        label: "Aml Warning Created",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <div>{value?.Created}</div>;
        },
      },
    ];
  }
};

export default compose(
  amlConnector,
  accountingConnector,
)(AmlFlaggedDepositsContent);
